'use client'

import { useId, useRef } from 'react'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery, Box } from '@mui/material'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

const BoxMolecule = () => {
	// Variables
	const muiTheme = useTheme()
	const patterId = useId()
	const boxRef = useRef<HTMLDivElement>(null)
	const lessThanSmall = useMediaQuery(muiTheme.breakpoints.down('sm'))
	const width = 100
	const height = 100

	// GSAP
	useGSAP(
		() => {
			gsap.timeline({
				scrollTrigger: {
					trigger: boxRef.current,
					start: 'top bottom',
					end: 'bottom top',
					// markers: true,
					onUpdate: self => {
						gsap.set('pattern', {
							attr: { x: `${self.progress * 100}%` }
						})
					}
				}
			})
		},
		{ scope: boxRef }
	)

	// Callbacks
	const generatePath = (padding: number) => {
		return (
			`M ${width - padding} ${height * 0.04 + padding} ` +
			`L ${width * 0.15 + padding} ${height * 0.00666667 + padding} ` +
			`L ${width * 0.15 + padding} ${height * 0.00666667 + padding} ` +
			`C ${width * 0.12666667 + padding} ${height * 0.00566667 + padding} ${width * 0.108 + padding} ${height * 0.005 + padding} ${width * 0.09333333 + padding} ${height * 0.00566667 + padding} ` +
			`C ${width * 0.07866667 + padding} ${height * 0.00633333 + padding} ${width * 0.06666667 + padding} ${height * 0.00833333 + padding} ${width * 0.05666667 + padding} ${height * 0.01333333 + padding} ` +
			`C ${width * 0.03866667 + padding} ${height * 0.02133333 + padding} ${width * 0.02433333 + padding} ${height * 0.03533333 + padding} ${width * 0.01533333 + padding} ${height * 0.05266667 + padding} ` +
			`C ${width * 0.01 + padding} ${height * 0.06266667 + padding} ${width * 0.00733333 + padding} ${height * 0.074 + padding} ${width * 0.00633333 + padding} ${height * 0.089 + padding} ` +
			`C ${width * 0.005 + padding} ${height * 0.104 + padding} ${width * 0.005 + padding} ${height * 0.12233333 + padding} ${width * 0.005 + padding} ${height * 0.14666667 + padding} ` +
			`V ${height - padding} ` +
			`H ${width - padding} ` +
			`Z`
		)
	}

	return (
		<Box
			ref={boxRef}
			width={1}
			height={1}
			position="absolute"
			top={0}
			left={0}
			zIndex={-1}
			sx={{
				'& svg': {
					width: { xs: 'auto', md: 1 },
					height: { xs: 1, md: 'auto' }
				}
			}}
		>
			<svg viewBox={`0 0 ${width} ${height}`}>
				<defs>
					<pattern id={patterId} patternUnits="userSpaceOnUse" width={lessThanSmall ? 9 : 4.5} height={lessThanSmall ? 7.5 : 3.75} patternTransform="rotate(45)">
						<line stroke="#2e3a64" strokeWidth={lessThanSmall ? 7.5 : 3.75} x1={0} y={0} x2={0} y2={lessThanSmall ? 7.5 : 3.75} />
					</pattern>
				</defs>

				<path fill="#192448" d={generatePath(0)} />
				<path fill={`url(#${patterId})`} fillOpacity={0.55} d={generatePath(lessThanSmall ? 2.5 : 1.25)} />
			</svg>
		</Box>
	)
}

export default BoxMolecule
